class Nav {
    constructor() {
        console.log("load navigation module");
        $("nav a.toggle").click((e) => {
            e.preventDefault();
            let submenu = $($(e.currentTarget).next(".submenu"));

            // Close all other submenus first
            $(".submenu").not(submenu).removeClass("visible");

            // Toggle the current submenu
            submenu.toggleClass("visible");
        });

    }
}

export default Nav;
